module.exports = __webpack_public_path__ + "media/2x/users-by-device-desktop@2x-299ae8c2.png";